import _ from 'underscore';
import Backbone from 'backbone';
import ApplicationEvents from 'constants/main/ApplicationEvents';
import UrlParser from 'utils/parsers/UrlParser';
import MainNavUtil from 'utils/MainNavUtil';
import ToolTipUtil from 'utils/ToolTipUtil';
import Loadable from 'utils/extensions/Loadable';
import NavigationUtil from 'utils/NavigationUtil';
// This is used to discard asynchronous requests that come back after the page is no longer loaded.
var currentPageInstance = null;

var Events = {
    ON_APPLICATION_EVENT_TRIGGERED: 'ON_APPLICATION_EVENT_TRIGGERED',
    HIDE_PAGE_VIEW_SUCCESS_MESSAGE: 'HIDE_PAGE_VIEW_SUCCESS_MESSAGE',
    SHOW_PAGE_VIEW_SUCCESS_MESSAGE: 'SHOW_PAGE_VIEW_SUCCESS_MESSAGE',
    HIDE_PAGE_VIEW_FAILURE_MESSAGE: 'HIDE_PAGE_VIEW_FAILURE_MESSAGE',
    SHOW_PAGE_VIEW_FAILURE_MESSAGE: 'SHOW_PAGE_VIEW_FAILURE_MESSAGE',
    HIDE_PAGE_VIEW_INFO_MESSAGE: 'HIDE_PAGE_VIEW_INFO_MESSAGE',
    SHOW_PAGE_VIEW_INFO_MESSAGE: 'SHOW_PAGE_VIEW_INFO_MESSAGE',
    HIDE_ALL_PAGE_VIEW_MESSAGES: 'HIDE_ALL_PAGE_VIEW_MESSAGES',
    ON_MESSAGE_CLOSED: 'ON_MESSAGE_CLOSED'
};

var PageView = Backbone.View.extend(Loadable).extend({
    pageClassName: '', // These are special classes that need to be added to this objects parent container.

    // enableGridCss: true, //adds class "page-inner" to pageContainer

    enableContainerCss: false, //adds class "container" to pageContainer

    enableSystemMessage: true,

    events: {},

    //        /**
    //         * Override this member in order to provide a list of application events this widget needs to be
    //         * notified of, such as a new or changed activity.
    //         *
    //         * Ex. "ACTIVITY_CHANGED": "onActivityChanged"  (takes two params, originator and options object).
    //         */
    //        applicationEvents: [
    //
    //        ],

    currentInstanceId: function() {
        return currentPageInstance;
    },

    initialize: function(args) {
        this.pageId = new Date().getTime();

        // We can only have one instance open at a time
        currentPageInstance = this.pageId;

        if (!args.userPreferences) {
            throw 'PageView: UserPreferences object required';
        }

        if (args.pageClassName) {
            this.pageClassName = args.pageClassName;
        }

        //page messages
        this._systemMessage = null;
        this._successMessage = null;
        this._failureMessage = null;
        this._infoMessage = null;

        this.userPreferences = args.userPreferences;

        this.setupSigninUrl();
        this.initializePage(args);

        this.delegateEvents(_.extend({ 'click a': NavigationUtil.anchorTagHandler }, this.events));

        var _this = this;
        this.onDependenciesLoaded = _.wrap(this.onDependenciesLoaded, function(func, tripCount) {
            if (_this.currentInstanceId() !== _this.pageId) {
                console.log('Discarding data, new page has been loaded');
            } else {
                return func.call(this, tripCount);
            }
        });

        this.render = _.wrap(this.render, function(func) {
            if (_this.currentInstanceId() !== _this.pageId) {
                console.log('Discarding data, render ignored.');
            } else {
                var returnVal = func.call(this);
                _this.postRenderSetup();
                return returnVal;
            }
        });
    },

    /**
     * Put scripts that need to be executed after render of the page here.
     */
    postRenderSetup: function() {
        this.renderTooltips();
        this.setupSmoothScroll();
        if (!this.disableScrollToTop) {
            jQuery('.main-body')
                .removeClass('dashboard')
                .scrollTop(0);
        }

        this.raiseApplicationEvent(ApplicationEvents.PAGE_LOADED);
    },

    setupSmoothScroll: function() {
        this.$('a[data-scroll="smooth"]').click(function(e) {
            e.preventDefault();
            var targetId = $(this).attr('href');
            var top = $(targetId).offset().top - 50;
            $('html, body')
                .stop()
                .animate({ scrollTop: top }, 500);
        });
    },

    /**
     * The base URL to be used with rewriteUrl functions in child page views.
     */
    getBaseUrl: function() {
        return '/modern';
    },

    /**
     * Place to put cleanup code. Called when page is unloaded.
     */
    onPageUnloaded: function() {
        this.unbind(null, null, this);

        if (typeof this.cleanUpReactComponents === 'function') {
            this.cleanUpReactComponents();
        }

        MainNavUtil.removeExpandCollapseHandlers();

        if (this.pageClassName) {
            var classes = this.pageClassName.trim().split(' ');

            classes = _.map(classes, function(cls) {
                return 'body-' + cls;
            });

            jQuery('body').removeClass(classes.join(' '));
        }
    },

    /**
     * Adds classes to the page
     */
    addPageClass: function(pageClass) {
        this.$el.addClass(pageClass);
    },

    /**
     * Removes classes from the page
     */
    removePageClass: function(pageClass) {
        this.$el.removeClass(pageClass);
    },

    /**
     * Raises an application event with the given name. Any extra argument provided will be provided
     * to the callback.
     *
     * @param eventName the applicationEvent name (Ex. 'ACTIVITY_ADDED').
     */
    raiseApplicationEvent: function(eventName) {
        var args = [];
        args.push(this);
        for (var i = 0; i < arguments.length; i++) {
            args.push(arguments[i]);
        }

        this.trigger(Events.ON_APPLICATION_EVENT_TRIGGERED, args);
    },

    /**
     * Returns if the user is logged in.
     */
    viewerIsAuthenticated: function() {
        return this.userPreferences.viewerIsAuthenticated;
    },

    getQueryStringValue: function(queryStringKey) {
        var url = document.URL,
            index = url.indexOf('?'),
            value = null;
        if (index !== -1) {
            var urlParser = new UrlParser();
            var queryStrings = urlParser.parseQueryString(url.substring(index + 1));
            if (_.has(queryStrings, queryStringKey)) {
                value = queryStrings[queryStringKey];
            }
        }
        return value;
    },

    setSystemMessage: function(message) {
        this._systemMessage = message;
    },

    getSystemMessage: function() {
        return this._systemMessage;
    },

    setSuccessMessage: function(message) {
        this._successMessage = message;
    },

    getSuccessMessage: function() {
        return this._successMessage;
    },

    setFailureMessage: function(message) {
        this._failureMessage = message;
    },

    getFailureMessage: function() {
        return this._failureMessage;
    },

    setInfoMessage: function(message) {
        this._infoMessage = message;
    },

    getInfoMessage: function() {
        return this._infoMessage;
    },

    hideSuccessMessage: function(clearText) {
        this.trigger(Events.HIDE_PAGE_VIEW_SUCCESS_MESSAGE, clearText);
    },

    hideFailureMessage: function(clearText) {
        this.trigger(Events.HIDE_PAGE_VIEW_FAILURE_MESSAGE, clearText);
    },

    hideInfoMessage: function(clearText) {
        this.trigger(Events.HIDE_PAGE_VIEW_INFO_MESSAGE, clearText);
    },

    hideAllMessages: function(clearText) {
        this.trigger(Events.HIDE_ALL_PAGE_VIEW_MESSAGES, clearText);
    },

    showSuccessMessage: function(message) {
        if (message) {
            this.setSuccessMessage(message);
        }
        this.trigger(Events.SHOW_PAGE_VIEW_SUCCESS_MESSAGE, this.getSuccessMessage());
    },

    showFailureMessage: function(message) {
        if (message) {
            this.setFailureMessage(message);
        }
        this.trigger(Events.SHOW_PAGE_VIEW_FAILURE_MESSAGE, this.getFailureMessage());
    },

    showInfoMessage: function(message) {
        if (message) {
            this.setInfoMessage(message);
        }
        this.trigger(Events.SHOW_PAGE_VIEW_INFO_MESSAGE, this.getInfoMessage());
    },

    showWaitCursor: function() {
        this.raiseApplicationEvent('SHOW_WAIT_CURSOR');
    },

    hideWaitCursor: function() {
        this.raiseApplicationEvent('HIDE_WAIT_CURSOR');
    },

    renderTooltips: function() {
        ToolTipUtil.renderTooltips.call(this);
    },

    onMessageClosed: function() {
        //
    },

    setupSigninUrl: function() {
        if (this.viewerIsAuthenticated()) {
            return;
        }
        // redirect user to current page after signin
        jQuery('.nav-signin-container .nav-signin').attr('href', this.getSigninUrl(window.location.href));
    },

    getSigninUrl: function(url) {
        return window.location.origin + '/modern/auth/logout/?url=' + url;
    }
});

PageView.Events = Events;

export default PageView;
